import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

/**
 * Protects routes requiring authentication and optional role checks.
 * @param {Object} props
 * @param {string} [props.allowedRole] - (Optional) Role required to access (e.g. 'patient', 'doctor')
 */
const ProtectedRoute = ({ allowedRole }) => {
    const { user } = useAuth();
    const token = localStorage.getItem('token');

    // If no user or no token, not authenticated
    if (!user || !token) {
        return <Navigate to="/login" replace />;
    }

    // If role is specified and doesn't match
    if (allowedRole && user.role !== allowedRole) {
        // Determine redirect based on actual role
        if (user.role === 'patient') return <Navigate to="/dashboard" replace />;
        if (user.role === 'doctor') return <Navigate to="/doctor" replace />;
        if (user.role === 'admin') return <Navigate to="/admin" replace />;
        return <Navigate to="/" replace />;
    }

    // Authorized
    return <Outlet />;
};

export default ProtectedRoute;
